import { GenericLookupType } from 'src/core/decorators/generic-lookup/generic-lookup-type.decorator';
import { GenericLookup } from 'src/core/decorators/generic-lookup/generic-lookup.decorator';

@GenericLookupType({
  code: 'FileCompression.Bitrate',
})
export class FileCompressionBitrate {
  @GenericLookup({
    code: 'FileCompression.Bitrate.Bitrate8k',
  })
  static bitrate8k: number;

  @GenericLookup({
    code: 'FileCompression.Bitrate.Bitrate12k',
  })
  static bitrate12k: number;

  @GenericLookup({
    code: 'FileCompression.Bitrate.Bitrate24k',
  })
  static bitrate24k: number;
}
